import makeStyles from '@ui/utils/makeStyles';
import rgba from 'polished/lib/color/rgba';

export default makeStyles()((theme) => ({
  inputWrapper: {
    background: theme.palette.common.white,
    borderRadius: 10,
    height: 36,

    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'box-shadow .2s',
    border: '1px solid #e4e4e4',
    boxShadow: `0px 0px 0px ${rgba(theme.palette.tertiary.main, 0)}`,
    '&:focus-within': {
      boxShadow: `0px 0px 10px ${rgba(theme.palette.tertiary.main, .3)}`,
    }
  },
  inputIcon: {
    fill: '#000',
    width: 20,
    height: 20,
    marginRight: theme.spacing(2.5),
  },
  input: {
    flex: 1,
    color: '#666666',
    border: 0,
    marginLeft: 20,
    fontSize: 13,
    fontFamily: theme.gh_vars.mabryMono,
    marginRight: 30,
    '&:focus': {
      outline: 0,
    },
    '&.placeholder': {
      color: '#8a8e8e',
    },
    '&:-moz-placeholder': {
      color: '#8a8e8e',
    },
    '&::-webkit-input-placeholder': {
      color: '#8a8e8e',
    },
  },
  button: {
    width: 125,
    height: 36,
    borderColor: '#b6bdc7',
    color: '#9fb9bc',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    '&:hover': {
      borderColor: '#b6bdc7',
    },
    '& svg': {
      fill: theme.palette.common.white,
      width: 20,
    },
    '&:focus': {
      outline: 'none',
    },
    marginRight: 9,
  },
}));
